import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Zap, Lock } from "lucide-react";
import authService from "../services/authService";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Aviso do modo automatico 24/7 - reutilizado nos paineis Afiliado
 * Brasil e Afiliado Internacional (USA), como pedido: "isso vai ficar
 * bem visivel na tela dos afiliados Brasil e USA".
 */
const AvisoAutomacao24h = ({ usuarioId }) => {
  const [status, setStatus] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (!usuarioId) return;
    authService
      .fetchAuth(`${BACKEND_URL}/api/perfil/automacao-24-7/${usuarioId}`)
      .then((resp) => (resp.ok ? resp.json() : null))
      .then((data) => data && setStatus(data.automacao_24_7_liberada))
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, [usuarioId]);

  if (carregando || !usuarioId) return null;

  if (status) {
    return (
      <Card className="p-3 bg-emerald-950/30 border-emerald-800 mb-4 flex items-center gap-2">
        <Zap className="w-4 h-4 text-emerald-400 shrink-0" />
        <p className="text-xs text-emerald-400">Modo automático 24/7 ativo - o robô está vendendo por você.</p>
      </Card>
    );
  }

  return (
    <Card className="p-3 bg-gray-800/50 border-gray-700 mb-4 flex items-center gap-3">
      <Lock className="w-4 h-4 text-gray-500 shrink-0" />
      <div className="flex-1">
        <p className="text-xs text-gray-300">Você está no modo manual. Quer vender 24 horas por dia, com o robô cuidando de tudo?</p>
      </div>
      <a
        href={`https://wa.me/5521964894355?text=${encodeURIComponent("Olá! Sou afiliado ClickHub e quero autorizar o modo automático 24/7 na minha conta.")}`}
        target="_blank"
        rel="noreferrer"
        className="shrink-0 bg-emerald-600 hover:bg-emerald-500 text-white text-[11px] font-medium px-3 py-1.5 rounded-lg whitespace-nowrap"
      >
        Falar com Suporte
      </a>
    </Card>
  );
};

export default AvisoAutomacao24h;
